export interface BSBookInfo {
  author: string;
  author_info: string;
  desc: string;
  cover: string;
  subname: string;
  name: string;
  isbn: string;
  title: string;
  date: string;
  date_timestamp?: number;
  tag?: string;
}

export interface BSBookInfoByMonth {
  month: string;
  books: BSBookInfo[];
}

export interface BookTagConfig {
  key: string;
  label: string;
  color: string;
  bgColor: string;
}

export const BOOK_TAGS: BookTagConfig[] = [
  { key: "psychology", label: "心理学", color: "#6B7023", bgColor: "#EAE6C8" },
  { key: "economics", label: "经济", color: "#A06818", bgColor: "#F2DFC4" },
  { key: "business", label: "商业", color: "#9C5A24", bgColor: "#F5E0CB" },
  { key: "management", label: "管理", color: "#7C5A3A", bgColor: "#F0E3CE" },
  { key: "investment", label: "投资", color: "#A06818", bgColor: "#F2DFC4" },
  { key: "history", label: "历史", color: "#9C5A24", bgColor: "#F5E0CB" },
  { key: "science", label: "科学", color: "#5B6E46", bgColor: "#E3E4CC" },
  { key: "literature", label: "文学", color: "#B0512B", bgColor: "#F6E7D2" },
  { key: "biography", label: "传记", color: "#7C5A3A", bgColor: "#F0E3CE" },
  { key: "technology", label: "技术", color: "#5B6E46", bgColor: "#E3E4CC" },
  { key: "philosophy", label: "哲学", color: "#8A6D1F", bgColor: "#F3E6C3" },
  { key: "art", label: "艺术", color: "#A04A3C", bgColor: "#F5DCC8" },
  { key: "other", label: "其他", color: "#8A7B64", bgColor: "#EFE8D8" },
];

export function getTagConfig(tag?: string): BookTagConfig {
  if (!tag) return BOOK_TAGS[BOOK_TAGS.length - 1];
  return BOOK_TAGS.find((t) => t.key === tag) ?? BOOK_TAGS[BOOK_TAGS.length - 1];
}
